import { HexaV2Icon, HexaV2Text } from '@/components/hexa-v2'
import { hexaBaseIcon } from '@/resources/enums/hexaIcons'
import { BUSINESS as dict } from '@/resources/dict'
import { HexaV2TagProps } from './types'
import * as S from './styles'

const HexaV2Tag = ({
  text,
  icon,
  svg,
  color,
  hasBorder,
  onClick,
}: HexaV2TagProps) => {
  return (
    <S.Tag color={color} hasBorder={hasBorder} onClick={onClick}>
      {icon && (
        <HexaV2Icon
          icon={hexaBaseIcon(icon)}
          size="small"
          className="tag-icon"
        />
      )}
      {svg && <img src={svg} alt={`${dict.icon} ${text}`} />}
      <HexaV2Text text={text} textStyle="bodySmall" className="tag-text" />
    </S.Tag>
  )
}

export default HexaV2Tag
